import { render, staticRenderFns } from "./IEmptyData.vue?vue&type=template&id=14b240d4"
import script from "./IEmptyData.vue?vue&type=script&lang=js"
export * from "./IEmptyData.vue?vue&type=script&lang=js"
import style0 from "./IEmptyData.vue?vue&type=style&index=0&id=14b240d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports